var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { State } from "../../../hooks/useUseCase";
import { createSelectedPmlFiles } from "../../../models/PmlFileSelect/SelectedPmlFiles";
import { defaultSortConditionObject, SortCondition } from "../../../models/PmlFileSelect/SortCondition";
import { ChangedFilterPayload, ChangedSortPayload } from "./usecases/ChangeFilterUseCase";
import { OpenedPmlFileSelectDialogPayload } from "./usecases/OpenPmlFileSelectDialogUseCase";
import { SelectedPmlFilePayload } from "./usecases/SelectPmlFileUseCase";
import { UnselectedPmlFilePayload } from "./usecases/UnselectPmlFileUseCase";
import { ClosedPmlFileSelectDialogPayload } from "./usecases/ClosePmlFileSelectDialogUseCase";
import { FilterCondition, defaultFilterConditionObject } from "../models/FilterCondition";
import { StartedLoadingPayload } from "./usecases/payload/StartedLoadingPayload";
import { FinishedLoadingPayload } from "./usecases/payload/FinishedLoadingPayload";
import { FetchedPmlFilesPayload } from "./usecases/FetchPmlFileUseCase";
import { ChangedOwnerNameVisibilityPayload } from "./usecases/ChangeOwnerNameVisibilityUseCase";
var defaultPagination = {
    totalCount: 0,
    page: 1,
    lastPage: 0,
};
var PmlFileSelectDialogState = /** @class */ (function (_super) {
    __extends(PmlFileSelectDialogState, _super);
    function PmlFileSelectDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pmlFiles = [];
        _this.selectedPmlFiles = createSelectedPmlFiles();
        _this.filterCondition = new FilterCondition(defaultFilterConditionObject);
        _this.sortCondition = new SortCondition(defaultSortConditionObject);
        _this.pagination = defaultPagination;
        _this.isLoading = false;
        _this.showOwnerName = false;
        return _this;
    }
    Object.defineProperty(PmlFileSelectDialogState.prototype, "selectedPmlFileId", {
        get: function () {
            return this.selectedPmlFiles.pmlFiles.map(function (pmlFile) { return pmlFile.id; });
        },
        enumerable: false,
        configurable: true
    });
    PmlFileSelectDialogState.prototype.reduce = function (payload) {
        var _a;
        if (payload instanceof OpenedPmlFileSelectDialogPayload) {
            this.pagination = defaultPagination;
            this.selectedPmlFiles = createSelectedPmlFiles(payload.selectionMode);
            if (Array.isArray(payload.defaultPmlFile)) {
                this.selectedPmlFiles.initialize(payload.defaultPmlFile);
            }
            else if (payload.defaultPmlFile) {
                this.selectedPmlFiles.initialize([payload.defaultPmlFile]);
            }
            else {
                this.selectedPmlFiles.initialize([]);
            }
            this.showOwnerName = false;
        }
        if (payload instanceof FetchedPmlFilesPayload) {
            this.pmlFiles = payload.pmlFiles;
            this.pagination = (_a = payload.pagination) !== null && _a !== void 0 ? _a : defaultPagination;
            this.isLoading = false;
        }
        if (payload instanceof UnselectedPmlFilePayload) {
            this.selectedPmlFiles.unselect(payload.pmlFile);
        }
        if (payload instanceof SelectedPmlFilePayload) {
            this.selectedPmlFiles.select(payload.pmlFile);
        }
        if (payload instanceof ChangedFilterPayload) {
            this.filterCondition = payload.filterCondition;
            this.selectedPmlFiles.clear();
        }
        if (payload instanceof ChangedSortPayload) {
            this.sortCondition = payload.sortCondition;
        }
        if (payload instanceof ClosedPmlFileSelectDialogPayload) {
            this.selectedPmlFiles.clear();
        }
        if (payload instanceof StartedLoadingPayload) {
            this.isLoading = true;
        }
        if (payload instanceof FinishedLoadingPayload) {
            this.isLoading = false;
        }
        if (payload instanceof ChangedOwnerNameVisibilityPayload) {
            this.showOwnerName = payload.showOwnerName;
        }
    };
    return PmlFileSelectDialogState;
}(State));
export { PmlFileSelectDialogState };
export var initialPmlFileSelectDialogState = new PmlFileSelectDialogState();
